import UserSignUpForm from "./UserSignUpForm";

export default UserSignUpForm;
